export default __webpack_public_path__ + "static/media/shape_01.477b6a23.png";